import React, { useState } from 'react';
import PageView from '../common/pageView';
import NflResearch from '../nflResearch/nflResearch';
import NhlResearch from '../nhlResearch/nhlResearch';
import NbaResearch from '../nbaResearch/nbaResearch';
import { fixtureDates } from '../nbaResearch/nbaMockData';
import globalStyles from '../globals.module.css';
import styles from './research.module.css';
import { slateDates } from '../nhlResearch/nhlMockData';

export default function Research() {
    const [sport, setSport] = useState('');
    const [date, setDate] = useState(slateDates[0]);
    const [nbaDate, setNbaDate] = useState(fixtureDates[0].value);
    const header = <div className={styles.pageTools}>
        <div className={styles.terminalSelector}>
            <label htmlFor="research-terminal">RESEARCH TERMINAL</label>
            <select id="research-terminal" className={globalStyles.standardSelect} value={sport} onChange={(event) => setSport(event.target.value)}>
                <option value="">SELECT SPORT</option>
                <option value="nfl">NFL</option>
                <option value="nhl">NHL</option>
                <option value="nba">NBA</option>
                <option value="mlb" disabled>MLB · COMING SOON</option>
            </select>
        </div>
        {sport && <div className={styles.terminalContext}>
            {sport === 'nfl' ? <div className={styles.weekControl}><span>SEASON</span><strong>2026</strong><span>WEEK</span><strong>12</strong></div> : sport === 'nba' ?
                <div className={styles.weekControl}><span>2026–27</span><label htmlFor="nba-fixture-date">SLATE</label><select id="nba-fixture-date" className={globalStyles.standardSelect} value={nbaDate} onChange={(event) => setNbaDate(event.target.value)}>{fixtureDates.map((item) => <option key={item.value} value={item.value}>{item.label}</option>)}</select></div> :
                <div className={styles.weekControl}><span>2026–27</span><label htmlFor="nhl-slate-date">SLATE</label><select id="nhl-slate-date" className={globalStyles.standardSelect} value={date} onChange={(event) => setDate(event.target.value)}>{slateDates.map((day) => <option key={day} value={day}>{day}</option>)}</select></div>}
            <span className={styles.mockBadge}>MOCK DATA</span>
        </div>}
    </div>;
    if (!sport) return <PageView header={header} headerClassName={styles.researchHeader} contentClassName={styles.researchContent}><div className={styles.emptyState}>Select a sport to open its research terminal.</div></PageView>;
    if (sport === 'nba') return <NbaResearch key={nbaDate} header={header} date={nbaDate} />;
    return sport === 'nhl' ? <NhlResearch key={date} header={header} date={date} /> : <NflResearch header={header} />;
}
